module.exports = __webpack_public_path__ + "assets/img/s4.1960c8b9.png";